module.exports = __webpack_public_path__ + "static/media/Twitter.6a20a252.png";